import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { CheckoutsTooltipResourcePackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CheckoutsTooltipResourcePackage";

export class CheckoutHourlyBonusWheelTooltip extends Container {
    private static readonly COLLECT_TEXT = 'AMAZING';
    private static readonly GIFT_TEXT = 'GIFT!';
    private static readonly COME_EVERY_TEXT = 'COME EVERY 30M';
    private static readonly TO_COLLECT_TEXT = 'TO COLLECT YOUR';
    private static readonly FREE_ROLLS_BONUS_TEXT = 'FREE DICE ROLLS!';

    public constructor(
        checkoutsTooltipResources: CheckoutsTooltipResourcePackage
    ) {
        super();
        const background = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_base_variant3_png);
        background.width = 562;
        background.height = 457;
        background.anchor.set(0.5);
        this.addChild(background);

        const tooltipUnion = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_union_variant1_png);
        tooltipUnion.width = 562;
        tooltipUnion.height = 225.13;
        tooltipUnion.anchor.set(0.5);
        tooltipUnion.position.y = -164;
        this.addChild(tooltipUnion);
        tooltipUnion.scale.y *= -1;

        const collectText = new Text(CheckoutHourlyBonusWheelTooltip.COLLECT_TEXT, new TooltipWhiteTextStyle());
        collectText.anchor.set(0.5, 0.5);
        collectText.position.set(-55, -80);
        this.addChild(collectText);

        const yourAmazingText = new Text(CheckoutHourlyBonusWheelTooltip.GIFT_TEXT, new TooltipYellowTextStyle());
        yourAmazingText.anchor.set(0.5, 0.5);
        yourAmazingText.position.set(91, -80);
        this.addChild(yourAmazingText);

        const comeEveryText = new Text(CheckoutHourlyBonusWheelTooltip.COME_EVERY_TEXT, new TooltipWhiteTextStyle());
        comeEveryText.anchor.set(0.5, 0.5);
        comeEveryText.position.set(0, -9);
        this.addChild(comeEveryText);

        const toCollectText = new Text(CheckoutHourlyBonusWheelTooltip.TO_COLLECT_TEXT, new TooltipWhiteTextStyle());
        toCollectText.anchor.set(0.5, 0.5);
        toCollectText.position.set(0, 61);
        this.addChild(toCollectText);

        const freeRollsBonusYellowText = new Text(CheckoutHourlyBonusWheelTooltip.FREE_ROLLS_BONUS_TEXT, new TooltipYellowTextStyle());
        freeRollsBonusYellowText.anchor.set(0.5, 0.5);
        freeRollsBonusYellowText.position.set(0, 136);
        this.addChild(freeRollsBonusYellowText);
    }
}

class TooltipWhiteTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            lineHeight: 73
        }));
    }
}

class TooltipYellowTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#FFC410",
                "#FFA21D"
            ],
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            lineHeight: 73
        }));
    }
}

class TooltipOrangeTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#FF9024"
            ],
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            lineHeight: 73
        }));
    }
}